export abstract class ModeleDeBase {
  id: string;

  constructor(id: string) {
    this.id = id;
  }

  abstract serialiser(): unknown;
}
